import React from "react";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import AnalyticsWrapper from "@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper";

import MainButton from "@configuratorware/configurator-frontendgui/Shared/Components/MainButton";
import customClassName from "@configuratorware/configurator-frontendgui/App/Utils/customClassName";
import { Toolbar } from "@material-ui/core";
import Button from "@material-ui/core/Button/Button";
import Typography from "@material-ui/core/Typography/Typography";
import ToolbarList from "../ToolbarList";
import AmountInput from "../AmountInput";

const styles = (theme) => ({
  amountPriceToolbar: {
    padding: 0,
    width: "100%",
    position: "fixed",
    bottom: 0,
    zIndex: 10,
    display: "flex",
    flexDirection: "column",
    height: theme.layout.footerbar.heightSm * 3,
    minHeight: theme.layout.footerbar.heightSm * 3,
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      height: theme.layout.footerbar.height,
      minHeight: theme.layout.footerbar.height,
    },

    "& > .ToolbarList": {
      order: 3,
      width: "100%",
      display: "flex",
      justifyContent: "space-evenly",
      [theme.breakpoints.up("sm")]: {
        order: 1,
        display: "block",
        width: "initial",
      },
    },
  },
  mainButton: {
    margin: 0,
    // marginLeft: "auto",
    padding: "6px 15px",
    lineHeight: 16,
    height: theme.layout.footerbar.heightSm,
    fontWeight: 800,
    width: "100%",
    background: `${theme.palette.secondary.main} !important`,
    color: theme.palette.secondary.text,
    borderRadius: 0,
    order: 2,
    overflow: " hidden",
    [theme.breakpoints.up("sm")]: {
      margin: 0,
      order: 3,
      minWidth: "25%",
      width: "auto",
      height: theme.layout.footerbar.height,
    },
    "&:hover": {
      background: "#45c417 !important",
      height: theme.layout.footerbar.height,
    },
    "&:active,&:focus": {
      background: "#1faa00 !important",
      height: theme.layout.footerbar.height,
    },
  },
  mainButtonLabel: {
    fontSize: 16,
    height: theme.layout.footerbar.heightSm,
    [theme.breakpoints.up("sm")]: {
      height: theme.layout.footerbar.height,
    },
  },
  priceContainer: {
    margin: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    order: 1,
    height: theme.layout.footerbar.heightSm,
    minHeight: theme.layout.footerbar.heightSm,
    [theme.breakpoints.up("sm")]: {
      height: theme.layout.footerbar.height,
      minHeight: theme.layout.footerbar.height,
    },
    width: "100%",
    background: "#FBFBFB",
    color: theme.palette.primary.darkText,
    "& .MuiButton-root": {
      "&:hover": {
        cursor: "pointer",
      },
      textTransform: "none",
      padding: 0,
    },

    [theme.breakpoints.up("sm")]: {
      width: "auto",
      margin: "0px 0px 0px auto",
      height: "100%",
      order: 2,
      background: "transparent",
    },
  },
  AmountPriceTypography: {
    fontSize: 16,
    padding: "0px 31px",
    fontWeight: "bold",
    minWidth: 100,
    textAlign: "end",
    marginLeft: " auto",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
    },
  },
  ToolbarIconButton: {
    "& span": {
      fontSize: 18,
    },
  },
  formattedPrice: {
    fontWeight: 800,
    fontSize: 16,
  },
  amountBtn: {
    fontSize: 16,
    borderRadius: 100,
    marginLeft: 1,
    height: theme.layout.footerbar.heightSm - 10,
    "&:hover": {
      background: "#F2F2F2",
    },
    "&:focus,&:active": {
      background: "#C9C9C9",
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      height: theme.layout.footerbar.height - 10,
      "&:hover": {
        background: "#959595",
      },
      "&:focus,&:active": {
        background: "#585858",
      },
    },
  },
});

class AmountPriceWrapper extends React.Component {
  onBlur = (...args) => {
    const { disabled, onBlur } = this.props;
    if (!disabled) {
      this.setState({ focused: false });
      onBlur && onBlur(...args);
    }
  };

  canCheckOut = () => true;

  handleChange = (variant, size) => (value) => {
    // variant sizes length should be > 1 because the button for saving is then visible
    if (
      variant &&
      variant.sizes &&
      variant.sizes.length > 1 &&
      size &&
      size.identifier
    ) {
      this.setState((state) => ({
        sizes: { ...state.sizes, [size.identifier]: value },
      }));
    } else if (isFunction(this.props.handleChange)) {
      this.props.handleChange(variant, size, value);
    }
  };

  render() {
    const {
      classes,
      amount,
      priceFormatted,
      showReceiveOfferForm,
      amountPriceLabel,
      tools,
      openPriceOverview,
      onChangeAmount,
      error,
      maxAmount,
    } = this.props;
    const changeAmountInput = (value) => {
      onChangeAmount(value);
    };

    return (
      <Toolbar
        key="amountPriceToolbar"
        color="primary"
        classes={{ regular: classes.amountPriceToolbar }}
      >
        <ToolbarList tools={tools} />

        <div className={classes.priceContainer}>
          <Button
            disableRipple
            onClick={openPriceOverview}
            className={classes.amountBtn}
          >
            <AmountInput
              key="amountInput"
              value={amount}
              max={maxAmount}
              onChange={changeAmountInput}
              onBlur={this.onBlur}
              amountLabel={amountPriceLabel}
              autoFocus
              disabled
              showAdornment
              error={error}
              onChangeDebounceWait={400}
              amountInputToolbar
            />
          </Button>
          <Typography
            variant="body1"
            classes={{
              root: classes.AmountPriceTypography,
            }}
          >
            <span className={classes.formattedPrice}>{priceFormatted}</span>
          </Typography>
        </div>

        <AnalyticsWrapper targetId="add_to_cart">
          <MainButton
            key="mainButton"
            className={customClassName("cta-button")}
            variant="contained"
            onClick={openPriceOverview}
            disabled={!this.canCheckOut()}
            classes={{
              root: classes.mainButton,
              label: classes.mainButtonLabel,
            }}
          >
            {t(
              showReceiveOfferForm
                ? "receiveOfferForm.sendButton"
                : "amountPrice.intoCart"
            )}
          </MainButton>
        </AnalyticsWrapper>
      </Toolbar>
    );
  }
}

export default withWidth()(
  withStyles(styles, { name: "AmountPriceWrapper" })(AmountPriceWrapper)
);
